require('core-js');require('regenerator-runtime/runtime');// webpack
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import { TweenMax } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
require('../../../wdh-foundation/dgs/dgs-api.js');
require('../../../wdh-foundation/dgs/dgs-events.js');
require('@demant/megamenu');
require('../../../wdh-foundation/dgs-sharing/dgs-sharing.js');
require('../../../wdh-foundation/dgs-utils/dgs-utils.js');
require('@demant/burgermenu');
require('jquery-bridget');
require('masonry-layout');
require('jquery-nice-select/js/jquery.nice-select.min.js');
require('jquery-ui-dist/jquery-ui.min.js');
require('iframe-resizer');
require('@demant/legacy/googlemaps');
require('../../corporate-template/js/feature/center-locator.js');
require('../../corporate-template/js/feature/center-spot.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-a-data-hierarchy.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-b-data-hierarchy-appframe-component.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-b-data-hierarchy-hubspot.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-b-data-hierarchy-multi-step.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-b-data-hierarchy-resource-center.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-data-hierarchy-dataset.js');
require('../../corporate-template/js/feature/data-hierarchy-spot/component-data-hierarchy-spot-ui-elements.js');
require('../../corporate-template/js/feature/video-spot.js');
require('../../corporate-template/js/feature/search-base.js');
require('../../corporate-template/js/feature/cookies.js');
require('../../corporate-template/js/feature/form.js');
require('../../corporate-template/js/feature/iframe.js');
require('../../corporate-template/js/feature/image-spot.js');
require('../../corporate-template/js/feature/intro-banner.js');
require('../../corporate-template/js/feature/rich-text.js');
require('../../corporate-template/js/feature/search.js');
require('../../corporate-template/js/feature/submenu-point-spot.js');
require('./feature/text-image-spot');
require('../../corporate-template/js/feature/two-section-grid.js');
require('./feature/component-extranet.js');
require('./feature/component-blog.js');
require('./feature/component-blog-categories.js');
require('./feature/component-center-locator.js');
require('./feature/center-regions-spot.js');
require('./feature/component-comments.js');
require('./feature/component-b-data-hierarchy-resource-center.js');
require('./feature/flex-spot-components/pop-up-banner.js');
require('../../corporate-template/js/project/main.js');
require('./custom-sharing.js');
require('./maico-header.js');
require('@demant/wdh-gdpr/lib/default.implementation.js');